import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";
import { useThemePalette } from "common/hooks/theme_palette";
import { icons } from "assets/AssetHelper";

const ZonesTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  formChildren,
  fulfillmentCenters,
  can_create,
  options,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { graySex, textGray } = useThemePalette();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang, setSupportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("zones.zones_details"),
            data: {
              images: details?.image && [{ id: 0, img: details?.image }],
              list: detailsData(t, { data: details }),
              checkBox: [
                {
                  checked: details?.is_fulfillment_center,
                  label: t("cities.fulfillment_center"),
                },
              ],
            },
          }}
          table={{
            list: data,
            listTitle: t("zones.title"),
            createBtnTitle: can_create && t("zones.new_zone"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "localized_data.en.name",
                Header: "Zone Name(EN)",
                sort: true,
              },
              {
                accessor: "localized_data.ar.name",
                Header: "Zone Name(AR)",
                sort: true,
              },
              {
                accessor: "is_fulfillment_center",
                Header: t("zones.is_fulfillment_center_zone"),
              },
              {
                accessor: "google_city.name",
                Header: t("common.city"),
              },
              { accessor: "radius", Header: t("zones.radius") },
              { accessor: "delivery_fees", Header: t("zones.delivery_fees") },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: true,
            searchInputPlaceholder: t("zones.search_by_zone"),
            isChecked: false,
            total_count: count,
            isSort: true,
            setFilterObj,
            className: "organization-table system-configurations-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            className: "main-table",
            actionsList, //if you want to add custom actions list
            headerChildren,

            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id
              ? { is_fulfillment_center: false }
              : initialValues(details, supportedLang),
            structure: () => structure(options, fulfillmentCenters, t),
            validationSchema: validationSchema(t),
            deleteFun: deleteFun,
            title: id ? t("zones.edit_zone") : t("zones.add_zone"),
            submitTitle: id ? t("admin_users.btn_update") : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
            formChildren,
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default ZonesTemplate;
